import { SystemEvent, SystemEventLevel } from 'bernie-logger';

export const CONTROLLER_EVENTS = {
  SEARCH_CONTROLLER_FETCH: new SystemEvent(SystemEventLevel.INFO, 'SEARCH_CONTROLLER_FETCH_TIME'),
  SEARCH_CONTROLLER_FETCH_FAILURE: new SystemEvent(SystemEventLevel.ERROR, 'SEARCH_CONTROLLER_FETCH_FAILURE'),
  INFOSITE_CONTROLLER_FETCH: new SystemEvent(SystemEventLevel.INFO, 'INFOSITE_CONTROLLER_FETCH_TIME'),
  INFOSITE_CONTROLLER_FETCH_FAILURE: new SystemEvent(SystemEventLevel.ERROR, 'INFOSITE_CONTROLLER_FETCH_FAILURE'),
};
